export const formatTranscriptWallClock = (
  milliseconds: number,
  timeZone?: string
) =>
  new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    ...(timeZone ? { timeZone } : {})
  }).format(new Date(milliseconds));
